<template>
  <div>
    <!-- <div v-if="isLoading">
      <h5>Cargando</h5>
      <h6>{{ loadingMsg }}</h6>
    </div> -->
    <div>
      <b-row>
        <b-col>
          <b-card class="mb-2">
            <b-row>
              <b-col cols="10" class="h3 mb-1">
                <span variant="primary">Configuración de Usuarios</span>
              </b-col>
              <b-col>
                <b-button variant="primary" class="m-1">
                  <b-iconstack font-scale="1" class="ml-1" title="Agregar">
                    <b-icon stacked icon="plus" shift-h="-11"></b-icon>
                    <b-icon stacked icon="person-fill"></b-icon>
                  </b-iconstack>
                  <span class="ml-3">Agregar</span>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card title="Listado de Usuarios">

            <b-table :busy="isBusy" class="mt-2 text-center" sticky-header no-border-collapse head-variant="light"
              style="min-height: 60vh;" striped :items="items" :fields="usersFields" responsive>
              <template #table-busy>
                <div class="text-center text-info my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Cargando...</strong>
                </div>
              </template>
              <template #cell(display_name)="data">
                <div>
                  {{ data.item.display_name }}
                  <b-badge v-if="data.item.active" pill variant="success">activo</b-badge>
                  <b-badge v-if="!data.item.active" pill variant="warning">inactivo</b-badge>
                </div>
              </template>
              <template #cell(login_date)="data">
                <span v-if="data.item.login_date">{{ formatDate(data.item.login_date) }}</span>
              </template>
              <template #cell(x_profile)="data">
                <div v-if="data.item.x_profile === 'Soporte'">
                  <b-iconstack class='enlarge-icon' font-scale="2" title="Soporte">
                    <b-icon stacked icon="person-fill" variant="dark-slate-gray" scale="0.7"></b-icon>
                    <b-icon stacked icon="gear-fill" shift-v="-3" shift-h="4" variant="un-blue" scale="0.4"></b-icon>
                  </b-iconstack>
                  <span class="mt-1 ml-2">{{ data.item.x_profile }}</span>
                </div>
                <div v-else-if="data.item.x_profile === 'Dirección'">
                  <b-iconstack class='enlarge-icon' font-scale="2" title="Dirección">
                    <b-icon stacked icon="person-fill" variant="dark-slate-gray" scale="0.7"></b-icon>
                    <b-icon stacked icon="briefcase-fill" shift-v="-3" shift-h="4" variant="un-blue" scale="0.4"></b-icon>
                  </b-iconstack>
                  <span class="mt-1 ml-2">{{ data.item.x_profile }}</span>
                </div>
                <div v-else-if="data.item.x_profile === 'Docentes'">
                  <b-iconstack class='enlarge-icon' font-scale="2" title="Docente">
                    <b-icon stacked icon="person-fill" variant="dark-slate-gray" scale="0.7"></b-icon>
                    <b-icon stacked icon="pen-fill" shift-v="-3" shift-h="4" variant="un-blue" scale="0.4"></b-icon>
                  </b-iconstack>
                  <span class="mt-1 ml-2">Docente</span>
                </div>
                <div v-else-if="data.item.x_profile === 'Secretaría'">
                  <b-iconstack class='enlarge-icon' font-scale="2" title="Secretaría">
                    <b-icon stacked icon="person-fill" variant="dark-slate-gray" scale="0.7"></b-icon>
                    <b-icon stacked icon="telephone-fill" shift-v="-3" shift-h="4" variant="un-blue" rotate="250"
                      scale="0.4"></b-icon>
                  </b-iconstack>
                  <span class="mt-1 ml-2">Secretaría</span>
                </div>
              </template>
              <template #cell(email)="data">
                <span v-if="data.item.email">{{ data.item.email }}</span>
              </template>
              <template #cell(actions)="data">
                <b-icon @click='guardar(data.item, data.index)' v-if="edit[data.index]" icon=check-lg
                  class="h2 mb-1 px-1 btn-like-icon" hover v-b-tooltip.hover title="Guardar" variant="success"></b-icon>
                <b-icon @click='cancelar(data.index)' v-if="edit[data.index]" icon=x-lg
                  class="h2 mb-1 ml-2 px-1 btn-like-icon" hover v-b-tooltip.hover title="Cancelar"
                  variant="danger"></b-icon>
                <b-icon @click='editar(data.index)' v-if="!edit[data.index]" icon=pencil-square
                  class="h2 mb-1 px-1 btn-like-icon" hover v-b-tooltip.hover title="Editar" variant="primary"></b-icon>
                <b-icon @click='borrar(data.item.id)' v-if="!edit[data.index]" icon=archive-fill
                  class="h2 mb-1 ml-2 px-1 btn-like-icon" hover v-b-tooltip.hover title="Archivar"
                  variant="primary"></b-icon>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { UsersService } from '@/services/users.service'
import { GroupsService } from '@/services/groups.service'
import dayjs from 'dayjs'
import 'dayjs/locale/es'
dayjs.locale({
  ...require('dayjs/locale/es'),
  weekdays: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
  weekdaysShort: 'Dom_Lun_Mar_Mié_Jue_Vie_Sáb'.split('_'),
  months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
  monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_')
})
// Set the locale globally
dayjs.locale('es')
// import { TeacherService } from '@/services/teacher.service'

export default {
  name: 'ConfigUsers',
  data () {
    return {
      isLoading: true,
      isBusy: true,
      edit: {},
      items: [],
      profiles: ['Dirección', 'Docentes', 'Soporte', 'Secretaria'],
      groupFields: ['display_name'],
      usersFields: [
        { key: 'display_name', label: 'Nombre', sortable: true },
        { key: 'login_date', label: 'Ultimo Acceso' },
        { key: 'email', label: 'Email' },
        { key: 'x_profile', label: 'Perfil de usuario', sortable: true },
        { key: 'actions', label: 'Acciones' }
      ]
    }
  },
  watch: {

  },
  computed: {

  },
  components: {
  },
  async created () {
    this.isLoading = true
    await this.updateLista()
    this.isLoading = false
  },
  methods: {

    formatDate (date) {
      return dayjs(date).format('ddd DD MMM YYYY HH:mm')
    },
    updateLista: async function () {
      try {
        this.items = await UsersService.list()
        await Promise.all(this.items.map(async (user) => {
          const profile_groups = []
          await Promise.all(user.groups_id.map(async (group) => {
            try {
              const [{ display_name }] = await GroupsService.read(group, this.groupFields)
              profile_groups.push(display_name)
            } catch (error) {
              console.error(error)
            }
          }))
          this.profiles.some((role) => {
            if (profile_groups.includes(role)) {
              // console.log('role: ', role)
              user.x_profile = role
              return true // Stop searching after finding a match
            }
          })
        }))
        this.isBusy = false
        // console.log(this.items)
      } catch (error) {
        console.error(error)
      }
    },
    async editar (index) {
      // TODO: define which changes can be performed in users and complete
    },
    async guardar (item, index) {
      if (item.id) {
        // TODO: complete with code to save changes
      } else {
        // this.itemsGroups[index].id = await ProductTemplateService.create(item)
      }
    },
    cancelar (index) {
      this.isLoading = true
      if (!this.items[index].id) {
        this.items.splice(index, 1)
      } else {
        this.edit[index] = false
      }
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
